/** Compara tipo de pesquisa (Csat/Nps), tolerante a caixa e valor numérico do enum. */
export function matchesSurveyType(
  actual: string | number | null | undefined,
  expected: 'csat' | 'nps' | string,
): boolean {
  const left = normalizeSurveyTypeToken(actual);
  const right = normalizeSurveyTypeToken(expected);
  if (!left || !right) {
    return false;
  }

  return left === right;
}

function normalizeSurveyTypeToken(value: string | number | null | undefined): string {
  if (value == null) {
    return '';
  }

  const raw = String(value).trim().toLowerCase();
  // SurveyType: Csat = 1, Nps = 2
  if (raw === '1' || raw === 'csat') {
    return 'csat';
  }

  if (raw === '2' || raw === 'nps') {
    return 'nps';
  }

  return raw;
}
